import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CartList from "../components/content/CartList";
import Navbar from "../components/layout/Navbar";
import { useHistory, Redirect } from "react-router-dom";
import {
  addAddress,
  deleteAddress,
  getAddress,
  getCarts,
  getProducts,
  setCheckout,
} from "../store/actions/productAction";

const Checkout = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [address, setAddress] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");
  const [cart, setCart] = useState([]);

  const products = useSelector((state) => state.product.products);
  const data = useSelector((state) => state.product.cart);
  const shippingAddress = useSelector((state) => state.product.address);

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      address,
    };
    dispatch(addAddress(data));
  };

  const deleteHandler = (id) => {
    dispatch(deleteAddress(id));
  };

  const checkOut = () => {
    dispatch(setCheckout(selectedAddress, history));
  };

  //   componentDidMount
  useEffect(() => {
    dispatch(getProducts());
    dispatch(getCarts());
    dispatch(getAddress());
  }, []);

  //   get products and cart then modified cart array
  useEffect(() => {
    if (products.length && data.length) {
      let copy = data.map((item) => {
        return {
          ...item,
          product: products.find((product) => product._id === item.productId),
        };
      });

      setCart([...copy]);
    }
  }, [products, data]);
  //   componentDidUpdate()

  return (
    <div id="checkout">
      <Navbar />
      {data.length === 0 ? (
        <Redirect to="/products" />
      ) : (
        <div className="row">
          <div className="col">
            <div className="container">
              <div className="card mt-2" style={{ height: "100vh" }}>
                <h3 className="mt-2 ms-2">Shipping</h3>
                <hr />
                <div className="card-body">
                  <div className="col-8">
                    <p>
                      Manage all the shipping addresses you want (work place,
                      home address.This way you won't have to enter the shipping
                      address manually with each order.
                    </p>
                    {shippingAddress.length !== 0 ? (
                      <>
                        {shippingAddress.map((data) => (
                          <div className="border border-secondary p-2">
                            <input
                              type="radio"
                              name="address"
                              id=""
                              value={data._id}
                              onChange={(e) =>
                                setSelectedAddress(e.target.value)
                              }
                            />
                            <span className="ms-1">{data.address}</span>
                            <button
                              className="btn btn-success btn-sm ms-3 mt-2"
                              onClick={() => deleteHandler(data._id)}
                            >
                              Delete
                            </button>
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="text-danger">
                        No addresses found. Please add one to proceed.
                      </p>
                    )}

                    <form onSubmit={submitHandler}>
                      <textarea
                        name=""
                        id=""
                        className="form-control mt-2"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      ></textarea>
                      <div>
                        <button className="btn-outline-info mt-3">
                          Add New Address
                        </button>
                      </div>
                    </form>
                    <h2 className="mt-4">Pricing</h2>
                    <p className="fs-3">Payment Method</p>
                    <input
                      type="radio"
                      id=""
                      className="form-check-input ms-2"
                      checked
                      readOnly
                    />
                    <label htmlFor="">Wallet</label>
                    <div>
                      <button
                        className="btn-outline-success mt-2"
                        onClick={checkOut}
                      >
                        place order
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 mt-2">
            <CartList cart={cart} checkoutPage={true} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
